import { CardTitle } from "../ui/card";
import { useDescriptionListContext } from "./DescriptionListContext";
import ValueRenderer from "./DescriptionValue";
import { DescriptionProps } from "./types";

const DescriptionTitle = ({ name, renderer }: DescriptionProps) => {
  const { data } = useDescriptionListContext();

  return (
    <CardTitle className="text-base">
      <ValueRenderer value={data?.[name] as string} renderer={renderer} />
    </CardTitle>
  );
};

export default DescriptionTitle;
